<template>
  <section class="image-grid-section">
    <v-container style="max-width: 1200px">
      <div class="text-center mb-12">
        <p class="section-eyebrow">{{ $t("imageGrid.eyebrow") }}</p>
        <h2 class="section-title">{{ $t("imageGrid.title") }}</h2>
        <p class="section-subtitle mx-auto mt-4" style="max-width: 560px">
          {{ $t("imageGrid.subtitle") }}
        </p>
      </div>

      <div class="img-grid">
        <div v-for="(item, i) in items" :key="i" class="img-card" @click="showAlert">
          <div>
            <img :src="`/assets/image_${i + 1}.png`" :alt="item.title" class="img-thumb" />
          </div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "ImageGrid",
  computed: {
    items() {
      return this.$t("imageGrid.items");
    },
  },
  methods: {
    showAlert() {
      this.$swal.fire('Та эхлээд сургуулиа бүртгүүлээрэй!')
    },
  },
};
</script>

<style scoped>
.image-grid-section {
  padding: 96px 16px;
  background: #fff;
}

.section-eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  color: #F77317;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 2.4rem;
  font-weight: 900;
  color: #4055af;
  letter-spacing: -1px;
  line-height: 1.15;
  margin: 0;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 1.9rem;
  }
}

.section-subtitle {
  font-size: 1.05rem;
  color: #666;
  line-height: 1.75;
}

/* 5-col desktop, 3-col tablet, 2-col mobile */
.img-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

@media (max-width: 960px) {
  .img-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 600px) {
  .img-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.img-card {
  background: white;
  border: 1px solid #ebebeb;
  border-radius: 16px;
  padding: 16px;
  transition: transform 0.22s ease, box-shadow 0.22s ease,
    border-color 0.22s ease;
  cursor: default;
}

.img-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 32px rgba(64, 85, 175, 0.1);
  border-color: #c8cfee;
}

.img-wrap {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  overflow: hidden;
  background: #f0f2ff;
}

.img-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.img-thumb {
  width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
  transition: transform 0.3s ease;
}

.img-card:hover .img-thumb {
  transform: scale(1.04);
}

.img-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #4055af;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.2px;
}

.img-desc {
  font-size: 0.78rem;
  color: #888;
  line-height: 1.6;
  margin: 4px 0 0;
}
</style>
